export default "__VITE_ASSET__DvyV_$PR__"